import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCuWRPRsz5R8Ei9aO8mqaLZDwqU1LrP10w",
  authDomain: "tank-check-compliance.firebaseapp.com",
  projectId: "tank-check-compliance",
  storageBucket: "tank-check-compliance.firebasestorage.app",
  messagingSenderId: "1099508444303",
  appId: "1:1099508444303:web:1389e6c6e47055c23914fa",
  measurementId: "G-FL41F3VLE1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize analytics only if supported
let analytics = null;
isSupported().then(supported => {
  if (supported) {
    analytics = getAnalytics(app);
  }
}).catch(error => {
  console.log('Analytics not supported or blocked', error);
});

export { app, auth, db, storage, analytics }; 